import React from 'react'
import styled from 'styled-components'
import { Button } from '../../../../ui/Button'

type Props = {
  role: 'finalApprover' | 'approver' | 'confirmer'
  setIsApprovalModalOpen: (isOpen: boolean) => void
  setIsRemandModalOpen: (isOpen: boolean) => void
  setIsConfirmModalOpen: (isOpen: boolean) => void
}

export const Approve2ButtonSection: React.FC<Props> = (props) => {
  return (
    <>
      <ButtonWrapper>
        <Button
          type="button"
          onClick={() => props.setIsApprovalModalOpen(true)}
          disabled={
            props.role === 'confirmer' || props.role === 'finalApprover'
          }
        >
          承認2
        </Button>
      </ButtonWrapper>
      <TwoButtonWrapper>
        <RemandedButton
          type="button"
          onClick={() => props.setIsRemandModalOpen(true)}
          disabled={
            props.role === 'confirmer' || props.role === 'finalApprover'
          }
        >
          差戻し
        </RemandedButton>
        <CancelButton
          type="button"
          onClick={() => props.setIsConfirmModalOpen(true)}
          disabled={
            props.role === 'confirmer' || props.role === 'finalApprover'
          }
        >
          取消
        </CancelButton>
      </TwoButtonWrapper>
    </>
  )
}

const ButtonWrapper = styled.div`
  margin-top: 40px;
  text-align: center;
`
const TwoButtonWrapper = styled.div`
  margin-top: 40px;
  text-align: center;
`
const RemandedButton = styled(Button)`
  background-color: #fe6f32;
  margin-right: 48px;
  &:hover {
    background-color: rgba(254, 111, 50, 0.5);
    color: rgb(255, 255, 255);
  }
`
const CancelButton = styled(Button)`
  background-color: #ea1c1c;
  &:hover {
    background-color: rgba(254, 57, 50, 0.5);
    color: rgb(255, 255, 255);
  }
`
